import { Dispatch, SetStateAction, createContext } from 'react';
import { UserChatAnswers } from '../chat/answers/chat_answers';
import { ProductLine, SourceType } from '../helpers/home_services.helper';

export interface ChatContextData {
  readonly sourceId: string | undefined;
  readonly campaignId: string | undefined;
  readonly userPublicId: string | undefined;
  readonly isLoadingInitialServerData: boolean;
  readonly sourceType: SourceType | undefined;
  readonly answerAttrs: UserChatAnswers;
  readonly sourceName: string | undefined;
  readonly zipCodeByIp: string | undefined;
  readonly setUserPublicId: Dispatch<SetStateAction<string | undefined>>;
  readonly setSourceId: Dispatch<SetStateAction<string | undefined>>;
  readonly setSourceType: Dispatch<SetStateAction<SourceType | undefined>>;
  readonly setAnswerAttrsCallback: (
    productLine: ProductLine,
    answer: any
  ) => void;
}

export const StoreContext = createContext<ChatContextData>(
  {} as ChatContextData
);
